import type { Tilde } from '../../lib/estado-de-entrega.ts';

/**
 * El estado de entrega junto a la hora de una burbuja saliente.
 *
 * **Se dibuja a plena opacidad y un punto más grande que la hora.** La primera
 * versión heredaba la opacidad del contenedor y aplicaba la suya encima —0,65 ×
 * 0,70 = 0,45— a 10px sobre un degradado de colores. Existía en el DOM y era
 * invisible, que para un indicador es peor que no ponerlo: da por informado algo
 * que nadie puede leer.
 *
 * No se apoya sólo en el color: `title` lleva el texto completo y hay un
 * `aria-label`, porque entregado y leído son el mismo dibujo con distinto tono.
 * Un operador que no distinga ese matiz —o que use lector de pantalla— tiene que
 * poder saber igual si el mensaje llegó.
 */
export function TildeDeEntrega({ tilde }: { tilde: Tilde }) {
  if (tilde.tildes === 0) {
    return (
      <span
        className="text-[13px] font-semibold text-amber-200"
        title={tilde.titulo}
        aria-label={tilde.titulo}
      >
        <span aria-hidden>⚠</span>
      </span>
    );
  }

  return (
    <span
      // Leído en celeste claro contra el blanco de enviado/entregado: sobre el
      // degradado de la burbuja es el par que mejor se distingue.
      className={`text-[12px] leading-none ${
        tilde.tono === 'leido' ? 'text-sky-300 font-semibold' : 'text-white/90'
      }`}
      title={tilde.titulo}
      aria-label={tilde.titulo}
    >
      <span aria-hidden>{tilde.tildes === 2 ? '✓✓' : '✓'}</span>
    </span>
  );
}
